import { Outlet, useLocation } from "react-router-dom"
import ErrorContainer from "./ErrorContainer"
import BrowserPermission from "../components/browserPermissions/BrowserPermission"



const RootLayout = () => {
    const location = useLocation()
    const isPdfPrintRoute = location.pathname === '/pdf-print' || location.pathname.startsWith('/pdf-print/')

    return <>
        {!isPdfPrintRoute && <BrowserPermission />}
        <Outlet />
        <ErrorContainer />
    </>
}

export default RootLayout